import { motion } from "framer-motion";
import { STEPS } from "../content";

const EASE = [0.22, 1, 0.36, 1];

export function Steps() {
  return (
    <section id="how" data-testid="how-it-works-section" className="mx-auto max-w-7xl scroll-mt-24 px-4 py-24 sm:px-6 sm:py-32 lg:px-8">
      <motion.p
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7, ease: EASE }}
        className="font-mono text-xs font-semibold uppercase tracking-[0.25em] text-acid"
      >
        How it works
      </motion.p>
      <motion.h2
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7, delay: 0.1, ease: EASE }}
        className="mt-3 max-w-2xl font-display text-3xl font-bold tracking-tight text-paper sm:text-4xl lg:text-5xl"
      >
        From Instagram export to your Wrapped in 3 steps
      </motion.h2>

      <div className="mt-14 grid gap-6 md:grid-cols-3">
        {STEPS.map((s, i) => (
          <motion.div
            key={s.n}
            data-testid={`step-card-${s.n}`}
            initial={{ opacity: 0, y: 36 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, delay: i * 0.12, ease: EASE }}
            whileHover={{ y: -6 }}
            className="group rounded-2xl border border-white/[0.08] bg-panel p-7 transition-colors duration-300 hover:border-acid/40"
          >
            <span className={`font-display text-5xl font-extrabold tracking-tight transition-transform duration-300 group-hover:scale-110 inline-block ${i === 1 ? "text-hot" : "text-acid/90"}`}>
              0{s.n}
            </span>
            <h3 className="mt-5 font-display text-xl font-bold tracking-tight text-paper">{s.title}</h3>
            <p className="mt-2.5 text-sm leading-relaxed text-dim">{s.body}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
